import {lowerCaseKeys, createDictionary, hideSpinner, showSpinner} from "src/utilities/utilityFunctions";
import {
    obtainMyRooms,
    obtainMySettings,
    obtainMyMedia,
    obtainMyActivites,
    obtainMyMediaByList,
    obtainListData, obtainMyLists, regActivityplay, addUserPoll
} from "src/services/gameTime/ApiServices";
import {createWebSocketSingleton} from "src/containers/websockets/SocketRouter";
import store from 'src/store';
import {makeAppTopMod} from "src/utilities/utilityFunctions";
import {contentURL} from "src/utilities/utilityFunctions";
import {updateCurrentActivityData} from "src/actions/gameTime";
import {updateGameTime} from "src/actions/gameTime";
import {obtainAccountDetails, obtainAccountDetailsByPerson} from "src/services/gameTime/Account/APIServices";
import {updateUser} from "src/actions/permissionsActions";
import {listsByActivity} from "src/services/gameTime/ApiServices";
import {updateAppSettings} from "src/actions/foundationActions";

export const runAllUserUpdates = () => {
    let storeData = store.getState();
    let retme=[];

    if (storeData.user.token) {

        obtainMyLists();
        retme.push("obtainMyLists");

        updateMyRooms();
        retme.push("updateMyRooms");
        //updateMyMedia(this.props);
/*
        updateMySettings();
        retme.push("updateMySettings");
        */
        updateMyActivites();
        retme.push("updateMyActivities");

        updateAccountDetailsByPerson();
        retme.push("updateAccountDetailsByPerson");
    }
    store.dispatch(updateAppSettings({userDataProcess:retme}));
};

export const makeHost = (socketId) =>{
	socketId = socketId ? socketId : store.getState().webSocketData.clientid;
    store.dispatch(updateCurrentActivityData({hostSocket:socketId}));

};

export const makeEmcee = (socketId) => {
    let stateData = store.getState();
    socketId = socketId && !isNaN(socketId) ? socketId : stateData.webSocketData.clientid;
    let emcees = [...stateData.currentActivityData.emceeSocket];
    if(emcees.indexOf(socketId)===-1){
        emcees.push(socketId);
        store.dispatch(updateCurrentActivityData({emceeSocket:emcees}));
    }
};

export const removeEmcee = (socketId) => {
    let stateData = store.getState();
    let emcees = [...stateData.currentActivityData.emceeSocket];
    socketId = socketId ? socketId : stateData.webSocketData?.clientid;
    let idx = emcees.indexOf(socketId);
    if(idx !== -1){
        emcees.splice(idx,1);
        store.dispatch(updateCurrentActivityData({emceeSocket:[...emcees]}));
    }
};



export const isCurrentHost = () =>{
    let newStore=store.getState();
    return newStore.currentActivityData ?
        newStore.currentActivityData.hostSocket && newStore.currentActivityData.hostSocket === newStore.webSocketData.clientid
            : false
};

export const isGuestOnly = () => {
    let stateData = store.getState();
    return !isNaN(stateData.currentActivityData.hostSocket) &&
        stateData.currentActivityData.hostSocket !== stateData.webSocketData.clientid &&
        stateData.currentActivityData.emceeSocket &&
        stateData.currentActivityData.emceeSocket?.indexOf(stateData.webSocketData.clientid)===-1
};

export const isCurrentEmcee = (clientid) =>{
    let newState = store.getState();
    clientid=clientid ? clientid : newState.webSocketData.clientid.toString();
    return newState.currentActivityData.emceeSocket.length && (newState.currentActivityData.emceeSocket.indexOf(clientid) > -1);
};

export const isFrontAndCenter = (props,clientid) =>{
    clientid=clientid ? clientid : props.webSocketData.clientid;
    return props.gameTime.frontAndCenter && props.gameTime.frontAndCenter === clientid;
};


/******** Activities ******/
let activityCount = 0;
let activityInt = {};
export const updateMyActivites = () => {
    clearTimeout(activityInt);
    obtainMyActivites(processActivites, failActivites);
};


const processActivites = (evt) =>{
    let returnedActivities = lowerCaseKeys(evt.data);
    let dict=createDictionary(returnedActivities,"activitycode","class");
    store.dispatch(updateGameTime({myActivities:returnedActivities,myActivitiesDict:dict}));

};

const failActivites = (evt) =>{
    console.dir("fail activites");
    console.dir(evt);
    if(activityCount <= 3) {
        activityInt = setTimeout(() => {
            activityCount = activityCount + 1;
            console.dir("Trying activites again");
            updateMyActivites()

        }, 3000);
    }

};

/******* Settings *******/
let settingsCount = 0;
let settingsInt = {};
export const updateMySettings = () => {
    clearTimeout(settingsInt);
    obtainMySettings(processSettings,failSettings);
};

const processSettings = (evt)=>{
    let res=lowerCaseKeys(evt.data.data);
    store.dispatch(updateGameTime({mySettings:res,mySettingsDict:createDictionary(res,"settingscode")}));
};


const failSettings = (evt)=>{
    console.dir("Fail Settings");
    console.dir(evt);
    if(settingsCount <= 3) {
        settingsCount = settingsCount + 1;
        settingsInt = setTimeout(() => {
            console.dir("Trying setting again");
            updateMySettings()

        }, 3000);
    }
};

export const obtainSettingsValue = (settingcode) =>{
    let storeData = store.getState();
    return  storeData.gameTime && storeData.gameTime.mySettingsDict && storeData.gameTime.mySettingsDict[settingcode]
        ? storeData.gameTime.mySettingsDict[settingcode].mysettingsvalue
        : null
};

let permissionsCount = 0;
let permissionsInt = {};
export const updateMyPermissions = () => {

}

export const establishDefaultRoom = () =>{
    let storeData = store.getState();
    let roomDict = storeData.gameTime.myRoomDict;
    let defRoom = obtainSettingsValue("defRoom")
        ? obtainSettingsValue("defRoom")
        : filterForDefaultRoom();
    if(defRoom && roomDict){
        roomDict["default"] = Object.assign({},roomDict[defRoom]);
    }
    store.dispatch(updateGameTime({myRoomDict:roomDict}));
};

const filterForDefaultRoom = () => {
    let storeData = store.getState();
  let defRoom = storeData.gameTime.myRooms.filter((item)=>{
      return item.peopletoroomtype ==='006E3818-31F6-456A-8AE5AA1BC6DDFF6B';
  });
    return defRoom[0].roomid;
};


/********* Rooms ************/
let roomInt = {};
let roomCount = 0;

export const updateMyRooms = () => {
    let storeData = store.getState();
    if(storeData.user.token) {
        obtainMyRooms(processRooms, failRooms);
    }
};

export const assembleRooms = (personal, invited) =>{
    return ([])
        .concat([{myroomname:"--- My Rooms --- "},...personal])
        .concat([{myroomname:"--- Invited Rooms --- "},...invited]);
};

export const createRoomDicts = (allRooms) => {
    let roomDict={};
    //eslint-disable-next-line array-callback-return
    allRooms.map((item)=>{
        roomDict[item.roomid] = item;
    });
    return roomDict;
};

export const processRooms = (e) => {
    //eslint-disable-next-line array-callback-return
    clearTimeout(roomInt);
    let allRooms = e.data.data.personal;
    let inviteRooms = e.data.data.invited;
    let roomDict=createDictionary(allRooms.concat(inviteRooms),"roomid","roomtypename");
    store.dispatch(updateGameTime({myRooms:allRooms,myRoomDict:roomDict,myInvitedRooms:inviteRooms}));
};

export const failRooms = (e) => {
    roomCount=roomCount + 1;
    if(roomCount <= 3) {
        roomInt = setTimeout(() => {
            updateMyRooms();
        }, 3000);
    }
};

export const obtainRoomDetails = (props,roomid) =>{
    return props.gameTime?.myRoomDict?.hasOwnProperty(roomid) ? props.gameTime.myRoomDict[roomid] : {};
};

export const obtainDefaultRoom = (props) => {
    return props.gameTime.myRoomDict && props.gameTime.myRoomDict.default ? props.gameTime.myRoomDict.default : null;
};

/******* Media ********/
export const updateMyMedia = () =>{
    obtainMyMedia(processMyMedia, failMedia);
};

const processMyMedia = (e) => {
    let storeData = store.getState();
    let returnedMedia = lowerCaseKeys(e.data);
    let dict=createDictionary(returnedMedia,"mymediaid");
    store.dispatch(updateGameTime({myMedia:returnedMedia,myMediaDict:dict}));
};

const failMedia= (e) => {
    console.dir("fail");
    console.dir(e);
};

export const extractThumbnail = (item) =>{
    if(item && item.hasOwnProperty("mymediatype")) {
        switch (item.mymediatype) {
            case "4CD5CAFD-E0A5-4044-A1110E4F4312D0B0":
                return item.mymediathumbnail;
            default:
                return item.mymediathumbnail ? contentURL() + item.mymediathumbnail : mediaTypeDefaultImage(item.mymediatype);

        }
    }
};

export const mediaTypeDefaultImage = (type) => {
    let mediaTypes = store.getState().gameTime?.mediaTypeDict;
    return (mediaTypes && mediaTypes[type] && mediaTypes[type].hasOwnProperty("mediatypedefaultimage")
        ?    mediaTypes[type]["mediatypedefaultimage"] : ""
    )
};

/***************** Lists and List Items *******************/
export const updateListElements = (listid) =>{
    if(listid) {
        updateListItems( listid);
        updateListData( listid);
    }

};



export const runAllListUpdates = (listid,liFunc=updateListItems,ldfunc=updateListData) => {
    let storeData = store.getState();
    let retme=[];

    if (storeData.user.token) {
        liFunc(listid);
        retme.push("updateListItems");
        ldfunc(listid);
        retme.push("updateListData");
    }
    store.dispatch(updateAppSettings({listDataProcess:retme}));
};

export const updateListData=(listid)=>{
    if(store.getState().user.hasOwnProperty("token") && listid) {
        obtainListData(listid,processListData,failListData);
    }
};

export const processListData = (e) => {
    let listData=lowerCaseKeys(e.data);
    store.dispatch(updateGameTime({currentList:listData.length ? listData[0] : {}}));
};

export const failListData = (e) =>{
    console.dir("fail lists");
    console.dir(e);
};

export const updateListItems = (listid) =>{
    if(store.getState().user.hasOwnProperty("token")) {
        obtainMyMediaByList(listid,processListItems,failListItems);
    }
};

export const processListItems=(e)=>{
    let listitems=lowerCaseKeys(e.data);
    store.dispatch(updateGameTime({currentListItems:listitems}));
};

export const failListItems = (e) =>{
    console.dir("fail list");
    console.dir(e);
};

export const processListGridItems=(e)=>{
    console.dir(e);
    let listitems=lowerCaseKeys(e.data);
    store.dispatch(updateGameTime({listGridListItems:listitems}));
};

export const failListGridItems = (e) =>{
    console.dir("fail list");
    console.dir(e);
};




export const changeActivity = (activityModule,hostModule=null,media=null) => {
    let stateData = store.getState();
    store.dispatch(updateCurrentActivityData({currentActivityName:activityModule,activeMedia:media}));

    if(hostModule){
        store.dispatch(updateAppSettings({myRoomModalComponentName:hostModule}));
    }
    makeAppTopMod(stateData.appSettings.roomModule);
};

export const getMediaClass = (mediaType,property="mediatypeclass") =>{
    let newState=store.getState();
    return newState.gameTime?.mediaTypeDict?.hasOwnProperty(mediaType) ?
        newState.gameTime.mediaTypeDict[mediaType][property] : null;
};

export const getMediaEditClass = (mediaType) =>{
    let newState=store.getState();
    return newState.gameTime?.mediaTypeDict?.hasOwnProperty(mediaType) ?
        newState.gameTime.mediaTypeDict[mediaType].mediatypeeditclass : null;
};


export const obtainListDetails = (listid) => {
    return store.getState().gameTime?.myListDict?.hasOwnProperty(listid) ?
        Object.assign({},store.getState().gameTime.myListDict[listid])
        : null;
    //return retme;
};

export const obtainMediaListsByActivity = (activityCode,addOns=[]) => {
    if(activityCode) {
        showSpinner();
        listsByActivity(activityCode, (actCode,evt)=>processListsByActivity(activityCode,evt,addOns), failListByActivity)
    }
};

const processListsByActivity = (activityCode,evt,addOns=[]) => {
    hideSpinner();
    store.dispatch(updateGameTime({activityLists:{[activityCode]:lowerCaseKeys(evt.data.concat(addOns))}}))
};

const failListByActivity = (activityCode,evt) => {
    hideSpinner();
    console.dir(evt);
};



export const obtainMediaForList = (props,listid) => {
    return props.gameTime.myMedia.filter((item)=>{
        return item.mediatolistlist?.mylistid === listid;
    })
};

export const updateAccountDetailsByPerson = (personid) => {
    obtainAccountDetailsByPerson(personid,processAccountDetails,failAccountDetails)
};

export const updateAccountDetails = (acctid) => {
    if(acctid) {
        obtainAccountDetails(acctid, processAccountDetails, failAccountDetails)
    }
};

const processAccountDetails = (evt) => {
    store.dispatch(updateUser({account:lowerCaseKeys(evt.data)}));
};

const failAccountDetails = (evt) => {
  console.dir("fail");
  console.dir(evt)
};

export const recordGameSpecs = (override=false) => {
    if(isCurrentHost() || override) {
        let stateData = store.getState();
        console.dir("running record");
        let accountid = stateData.user?.account?.accountuuid ? stateData.user.account.accountuuid : 0;
        let activityCode = stateData.gameState?.activityKey ? stateData.gameState.activityKey : '';
        let useas = stateData.user.firstname ? stateData.user.firstname : "";
        let gameMode = stateData.gameState.gameMode ? stateData.gameState.gameMode : "";
        let imageListid = stateData.gameState.imageListId ? stateData.gameState.imageListId : "";
        let activeMedia = stateData.gameState.activeMedia?.mymediaid ? stateData.gameState.activeMedia.mymediaid : "";
        let numPlayers = stateData.gameState.teams ? Object.keys(stateData.gameState.teams).length : 0;

        let formData = {
            account: accountid,
            activity: activityCode,
            username: useas,
            gameMode: gameMode,
            listid: imageListid,
            mediaid: activeMedia,
            numPlayers: numPlayers
        };
        regActivityplay(formData, processGameSpec, failGameSpec)
    }
};

const processGameSpec = (evt) => {
    //console.dir(evt);
};

const failGameSpec = (evt) => {

};


export const saveUserPoll = (questionCode,index,answer) => {
    let storeData = store.getState();
    addUserPoll({questionCode:questionCode,index:index,answer:answer,useas:storeData.user.firstname},processUserPoll,failUserPoll)
};

const processUserPoll = (evt) => {
    console.dir(evt);
};

const failUserPoll = (evt) => {
    console.dir(evt);
};

export const scrambleArray = (choicesArray) =>{
    choicesArray= choicesArray ? choicesArray : [];
    let scrambledArray=[];
    while(choicesArray.length){
        let randnum=Math.floor(Math.random() * choicesArray.length);
        let tileObj=choicesArray.splice(randnum,1)[0];
        scrambledArray.push(tileObj);
    }
    return scrambledArray;
};
